import { ErrorMessage } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

import './SlectInputField.styles.css';

const SlectInputField = ({ Labels, ClassName, Name, placeHolder, value, className, errors, isInvalid, isValid, onChange, onBlur, options, emptySelection }) => {

  return (
    <Form.Group className="mb-3">
      {Labels && <><Form.Label>{Labels}</Form.Label><br /></>}
      <Form.Select
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        aria-label="Default select example"
        name={Name}
        isInvalid={isInvalid}
        isValid={isValid}
        className={className}>
        {!emptySelection && <option>{placeHolder}</option>}
        {emptySelection && <option className='options' label={emptySelection.label} value={emptySelection.value}>{emptySelection.label}</option>}
        {
          options?.map(data =>
            <option className='options' label={data.label} value={data.value}>{data.label}</option>
          )
        }
      </Form.Select>
      <ErrorMessage name={Name} component="div" style={{ color: 'red', marginBottom: '5px' }} />
    </Form.Group>
  );
};

export default SlectInputField;
